<template>
  <div class="tools-partners-my-colabs">
    <div class="row justify-content-between">
      <div class="d-flex align-items-center col-lg-6">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pagination.count"
      class="container centralize-row text-center pt-5"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.png"
          />
          <h5>Você ainda não participa de nenhuma central</h5>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- desktop area -->
      <data-table
        new-design
        class="d-none d-lg-block"
        :data="myColabs"
        :columns="columns"
        :last-column-fr="1"
      >
        <template #default="{ item }">
          <span>
            {{ item.company.name }}
          </span>
          <div>
            <span :class="item.is_blocked ? 'inactice-badge' : 'active-badge'">
              {{ item.is_blocked ? "Bloqueado" : "Aprovado" }}
            </span>
          </div>
        </template>
      </data-table>
      <!-- end of desktop -->
      <!-- mobile area -->
      <data-table
        new-design
        class="d-lg-none"
        :data="myColabs"
        :columns="['', '']"
      >
        <template #default="{ item }">
          <div class="d-flex flex-column py-5 responsive-table">
            <span>
              <strong>Usuário: </strong>
              {{ item.company.name }}
            </span>
            <span>
              <strong>Status: </strong>
              <span
                :class="item.is_blocked ? 'inactice-badge' : 'active-badge'"
              >
                {{ item.is_blocked ? "Bloqueado" : "Aprovado" }}
              </span>
            </span>
          </div>
        </template>
      </data-table>
      <!-- end of mobile -->
      <div class="mt-5 d-flex justify-content-end">
        <paginator
          v-show="myColabs.length && !loading"
          :pagination="pagination"
          @on-update="dispatch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      columns: ["Usuário", "Status"],
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["myColabs"])
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch(offset = null) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getMyColabs", { offset })
        .then(
          ({ count, next, previous }) =>
            (this.pagination = { count, next, previous })
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
